<p-table #dtDic [value]="solicitudResoluciones" [columns]="cols" responsiveLayout="scroll" [rows]="10"
    [globalFilterFields]="['numeroExpediente','usuario','estado']" [paginator]="true" [rowsPerPageOptions]="[10,25,50]"
    [showCurrentPageReport]="true" [styleClass]="'p-datatable-sm'"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} resoluciones" selectionMode="multiple"
    [rowHover]="true" dataKey="id">
    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center py
        \-2">
            <h5 class="m-0">Resoluciones:</h5>
            <section>

                <button pButton label="Plantilla de resolución" icon="pi pi-file"
                    class="p-button-rounded p-button-info mr-2 custom-button-width" pTooltip="Plantilla resolución"
                    tooltipPosition="top" (click)="setAction('dowload')"></button>

                <button pButton label="Subir resolución" icon="pi pi-upload"
                    class="p-button-rounded p-button-info mr-2 custom-button-width" pTooltip="Subir resolución"
                    tooltipPosition="top" (click)="setAction('upload')"></button>

                <p-button *ngIf="!is_solicitudAprobada" label="Aprobar Solicitud" class="p-button-rounded p-button-default mr-2 custom-button-width"
                    icon="pi pi-check-circle" (onClick)="confirm($event)"></p-button>



                <!-- BOTON PARA GENERAR EL CARNET JUNTO A SU PROPIO INDICADOR DE CARGA -->

                <p-button
                id="btnGenerarCartet"
                label="Descargar carnet PDF"
                    *ngIf="is_rp && is_solicitudAprobada"
                    class="p-button-rounded p-button-default mr-2 custom-button-width"
                    icon="pi pi-download"
                    [style]="{ 'background': 'orange' }"
                    (click)="selected && recortarFotoCarnetPDF(selected)">

                </p-button>
                <p-progressSpinner *ngIf="selected?.carnetLoading " [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>



                <p-confirmPopup #confirmPopupRef>
                    <ng-template pTemplate="headless" let-message let-test>
                        <div class="border-round p-3">
                            <span>{{ message.message }}</span>
                            <div class="flex align-items-center gap-2 mt-3">
                                <p-button (onClick)="accept()" label="Save" size="small" />
                                <p-button (onClick)="reject()" label="Cancel" [outlined]="true" size="small" />
                            </div>
                        </div>
                    </ng-template>
                </p-confirmPopup>
                <!--                <p-button (onClick)="confirm($event)" label="Save" />-->
            </section>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="numeroExpediente">Ref
                <p-sortIcon field="numeroExpediente"></p-sortIcon>
            </th>
            <th pSortableColumn="estado">Estado
                <p-sortIcon field="estado"></p-sortIcon>
            </th>
            <th pSortableColumn="usuario">Usuario
                <p-sortIcon field="usuario"></p-sortIcon>
            </th>
            <th pSortableColumn="fechaCreacion">Fecha
                <p-sortIcon field="fechaCreacion"></p-sortIcon>
            </th>
            <th>Opción</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-resoluciones>
        <tr>
            <td>
                <span class="p-column-title">Ref</span>
                {{ resoluciones.numeroExpediente }}
            </td>
            <td>
                <span class="p-column-title">Estado</span>
                <p-tag [style]="tagStyle(resoluciones.estado)"
                    [value]="resoluciones.estado==true?'Activo':'Inactivo'"></p-tag>
            </td>
            <td>
                <span class="p-column-title">Usuario</span>
                {{ resoluciones.usuario }}
            </td>
            <td>
                <span class="p-column-title">Fecha</span>
                {{ resoluciones.fechaCreacion }}
            </td>
            <td>
                <p-button icon="pi pi-upload" class="p-button-rounded mr-2" [rounded]="true" [outlined]="true"
                    pTooltip="Upload" severity="info"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>


@switch (currentAction()) {
@case ('dowload') {
<app-descargar-plantilla [isVisible]="showAction()" (dialogClosed)="setAction(null)"></app-descargar-plantilla>
}
@case ('upload') {
<app-subir-resolucion [isVisible]="showAction()" [projectId]="selected?.idProyecto ?? ''"
    [solicitudId]="selected?.idSolicitud ?? ''" (dialogClosed)="setAction(null)"></app-subir-resolucion>
}
@default {
}
}
<app-recorte-foto
  [(visible)]="recorteFotoVisible"
  [imageUrl]="fotoParaRecortar"
  (fotoRecortada)="onFotoRecortada($event)"
  (cerrado)="onRecorteFotoCerrado()">
</app-recorte-foto>